import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'store';
import { fetchProfileData, selectUser } from 'store/usersReducer';
import { formatPhoneNumber } from 'utils/formatter';
import Card from 'components/Card';
import ModalChangePhone from 'components/Modals/ModalChangePhone';
import { ReactComponent as EditIcon } from 'assets/imgs/edit.svg';
import { ReactComponent as MenuIcon } from 'assets/imgs/menu-dots.svg';
import classes from './profile.module.scss';

const Profile: React.FC = () => {
	const dispatch = useDispatch();
	const user = useSelector(selectUser);
	const [isLoading, setIsLoading] = useState(true);
	const [modalOpen, setModalOpen] = useState('');
	const [isOpenLinks, setIsOpenLinks] = useState(false);
	const title = `${user?.lastName || ''} ${user?.firstName || ''}${user?.middleName ? ` ${user?.middleName}` : ''}`;

	const getProfileData = async (): Promise<void> => {
		setIsLoading(true);
		try {
			await dispatch(fetchProfileData()).unwrap();
		} catch (err) {
			console.log(err);
		}
		setIsLoading(false);
	};

	const handleToggleLinks = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation()
		setIsOpenLinks(!isOpenLinks)
	};

	const handleOutsideClick = () => {
		setIsOpenLinks(false);
	};

	useEffect(() => {
		document.addEventListener('click', handleOutsideClick);
		return () => {
			document.removeEventListener('click', handleOutsideClick);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		getProfileData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleChangePhone = () => {
		setModalOpen('phone');
	};

	const handleCloseModal = () => {
		setModalOpen('');
	};

	const profileData: { [key: string]: string | number } = {
		'ID': user?.id || '--',
		'Почта': user?.email || '--',
		'Номер телефона': user?.phone ? formatPhoneNumber(user.phone) : '--',
	};

	return (
		<div className={classes.profile}>
			<div className={classes.header}>
				<div className={classes.title}>{title}</div>
				<div className={classes.menuIcon} onClick={handleToggleLinks}>
					<MenuIcon />
					{isOpenLinks && (
						<div className={classes.menu}>
							<Link className={classes.menuItem} target="_blank" rel='noreferrer' to="/privacy-policy">Политика конфиденциальности</Link>
							<Link className={classes.menuItem} target="_blank" rel='noreferrer' to="/terms">Пользовательское соглашение</Link>
							<Link className={classes.menuItem} target="_blank" rel='noreferrer' to="/public-offer">Публичная оферта</Link>
						</div>
					)}
				</div>
			</div>
			{/* TODO: add skeleton loader */}
			{!isLoading && (
				<Card className={classes.profileData}>
					{Object.keys(profileData).map((infoTitle) => (
						<div className={classes.info} key={infoTitle}>
							<div className={classes.infoTitle}>{infoTitle}</div>
							<div className={classes.infoText}>{profileData[infoTitle]}</div>
							{infoTitle === 'Номер телефона' && (
								<EditIcon className={classes.infoIcon} onClick={handleChangePhone} />
							)}
						</div>
					))}
				</Card>
			)}
			<ModalChangePhone
				className={classes.modal}
				isOpen={modalOpen === 'phone'}
				onClose={handleCloseModal}
			/>
		</div>
	);
};

export default Profile;
